import { TaskState } from '../enums/task-state.enum';
import { TaskType } from '../enums/task-type.enum';
import { SubjectType } from '../enums/subject-type.enum';
import { WorkflowArea } from '../enums/workflow-area.enum';

export interface TaskMetaInformation {
    id: string;
    projectId: string;
    sectionName: string;
    sectionId: string;
    description: string;
    assignedTo: string | null;
    dueDate: Date;
    taskState: TaskState;
    area: WorkflowArea;
    taskType: TaskType;
    staticTaskReference?: string;
    /** Missing on person tasks (`personName` instead). */
    companyName?: string;
    /** REV-22155 — missing = COMPANY. */
    subjectType?: SubjectType;
    personId?: string;
    /** "Nachname Vorname". */
    personName?: string;
    latestComment: string | null;
}
